var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      attrs: {
        visible: _vm.visible,
        title: _vm.goods ? _vm.goods.materialName : "选择选项",
        maskClosable: false,
        width: "480px",
        okText: "加入点单",
        cancelText: "取消",
        okButtonProps: { props: { disabled: !_vm.valid } },
      },
      on: {
        ok: _vm.handleOk,
        cancel: function ($event) {
          return _vm.$emit("cancel")
        },
      },
    },
    [
      _vm.goods
        ? _c(
            "div",
            { staticClass: "opt-body" },
            [
              _c("div", { staticClass: "opt-price" }, [
                _vm._v("\n      参考价："),
                _c("span", { staticClass: "opt-price-num" }, [
                  _vm._v("¥" + _vm._s(_vm.fmt(_vm.basePrice))),
                ]),
                _vm.extraAmount > 0
                  ? _c("span", { staticClass: "opt-price-extra" }, [
                      _vm._v("+ 加料 ¥" + _vm._s(_vm.fmt(_vm.extraAmount))),
                    ])
                  : _vm._e(),
              ]),
              _vm._l(_vm.goods.options, function (group) {
                return _c("div", { key: group.id, staticClass: "opt-group" }, [
                  _c(
                    "div",
                    { staticClass: "opt-group-head" },
                    [
                      _c("span", { staticClass: "opt-group-name" }, [
                        _vm._v(_vm._s(group.name)),
                      ]),
                      _vm.isRequired(group)
                        ? _c("a-tag", { attrs: { color: "red" } }, [
                            _vm._v("必选"),
                          ])
                        : _vm._e(),
                      _c("span", { staticClass: "opt-group-type" }, [
                        _vm._v(
                          _vm._s(group.type === "EXTRA" ? "多选" : "单选")
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "opt-values" },
                    _vm._l(group.values, function (v) {
                      return _c(
                        "div",
                        {
                          key: v.id,
                          staticClass: "opt-value",
                          class: { active: _vm.isSelected(group, v) },
                          on: {
                            click: function ($event) {
                              return _vm.toggle(group, v)
                            },
                          },
                        },
                        [
                          _c("span", [_vm._v(_vm._s(v.name))]),
                          Number(v.addPrice) > 0
                            ? _c("span", { staticClass: "opt-add" }, [
                                _vm._v("+¥" + _vm._s(_vm.fmt(v.addPrice))),
                              ])
                            : _vm._e(),
                        ]
                      )
                    }),
                    0
                  ),
                ])
              }),
              _c("div", { staticClass: "opt-row" }, [
                _c("span", { staticClass: "opt-label" }, [_vm._v("数量")]),
                _c(
                  "div",
                  { staticClass: "qty-step" },
                  [
                    _c(
                      "a-button",
                      {
                        attrs: { size: "small", disabled: _vm.quantity <= 1 },
                        on: {
                          click: function ($event) {
                            _vm.quantity > 1 && _vm.quantity--
                          },
                        },
                      },
                      [_vm._v("-")]
                    ),
                    _c("span", { staticClass: "qty-num" }, [
                      _vm._v(_vm._s(_vm.quantity)),
                    ]),
                    _c(
                      "a-button",
                      {
                        attrs: { size: "small" },
                        on: {
                          click: function ($event) {
                            _vm.quantity < 999 && _vm.quantity++
                          },
                        },
                      },
                      [_vm._v("+")]
                    ),
                  ],
                  1
                ),
              ]),
              _c(
                "div",
                { staticClass: "opt-row" },
                [
                  _c("span", { staticClass: "opt-label" }, [_vm._v("备注")]),
                  _c("a-input", {
                    staticStyle: { flex: "1" },
                    attrs: { placeholder: "口味备注（选填）" },
                    model: {
                      value: _vm.remark,
                      callback: function ($$v) {
                        _vm.remark = $$v
                      },
                      expression: "remark",
                    },
                  }),
                ],
                1
              ),
            ],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }